export const DEFAULT_HITS_PER_PAGE = 20;
export const DEFAULT_TEXT = {
  BUTTONS: {
    SHOW_MORE: 'Show more',
    SHOW_LESS: 'Show less',
    RESET: 'Reset search',
    SEARCH: 'search',
    REFINE: 'Refine {{count}} result(s)'
  },
  EMPTY_STATE: {
    TITLE: 'No results where found.',
    BODY: 'Try a different search term or try adjusting the filters.'
  },
  SEARCH_BAR: {
    PLACEHOLDER: 'Search term'
  },
  ACTIVE_FACETS: {
    EMPTY_STATE: 'No active filters selected'
  },
  STATS: {
    TOTAL_RESULTS: 'Results: {{count}}'
  },
  SORT_BY: {
    PLACEHOLDER: 'Sort by'
  }
};

/**
 * Replace a param in a default text string with a passed value
 * @param {string} text
 * @param {string} paramKey
 * @param {string} paramValue
 * @returns string
 */
export const getDefaultText = (text, paramKey, paramValue) => {
  const textToReplace = text || '';
  const paramToReplace = paramKey || '';
  const paramValueToPlace = paramValue || '';
  return textToReplace.replace("{{".concat(paramToReplace, "}}"), paramValueToPlace);
};
export default {
  DEFAULT_TEXT,
  getDefaultText
};